import { ClarityType } from '../clarityValue';
const trueCV = () => ({ type: ClarityType.BoolTrue });
const falseCV = () => ({ type: ClarityType.BoolFalse });
export { trueCV, falseCV };
//# sourceMappingURL=booleanCV.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/dist/esm/clarity/types/booleanCV.js
// module id = null
// module chunks = 